// src/app/u3141LandRegister/components/form/u3141ChildLotChain/U3141UseFetchPropertyIndexHandlers.ts
export interface U3141UseFetchPropertyIndexHandlersParams {
  doFetchPropertyIndexFn: (id: string, childLotChainId: string) => Promise<{ data: { id?: string; status?: string; result?: { id?: string; status?: string } } }>;
  onSuccess?: (jobId: string) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseFetchPropertyIndexHandlersReturn {
  fetchPropertyIndex: (id: string, childLotChainId: string) => Promise<void>;
}

/**
 * Handlers pour la récupération de l'index des immeubles (job asynchrone).
 * Aligné sur useU3141UseFetchHistoriqueCadastralHandlers : retour job { id, status }, toast "en cours",
 * notification WebSocket pour refetch à la fin.
 */
export function useU3141UseFetchPropertyIndexHandlers({
  doFetchPropertyIndexFn,
  onSuccess,
  onError,
}: U3141UseFetchPropertyIndexHandlersParams): U3141UseFetchPropertyIndexHandlersReturn {
  const fetchPropertyIndex = async (id: string, childLotChainId: string) => {
    try {
      const response = await doFetchPropertyIndexFn(id, childLotChainId);
      const data = response?.data as Record<string, unknown> | undefined;
      const result = (data?.result ?? data?.data) as Record<string, unknown> | undefined;
      const rawId = data?.id ?? result?.id;
      const jobId = typeof rawId === "string" ? rawId : "";

      onSuccess?.(jobId);
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { fetchPropertyIndex };
}
